export default [
  {
    path: '/invitation/:token',
    name: 'InviteAccepted',
    props: true,
    component: () => import(/* webpackChunkName: "networks-invite" */ '@/views/InviteAccepted.vue'),
  },
  {
    path: '/invitation-declined',
    name: 'InviteDeclined',
    component: () => import(/* webpackChunkName: "networks-invite" */ '@/views/InviteDeclined.vue'),
  },

  {
    name: 'join-network',
    path: '/join-network',
    meta: {},
    component: () => import(/* webpackChunkName: "networks-invite" */ '@/views/networks/JoinNetwork.vue'),
  },
];
